import * as React from "react";

import MaskedInput from "react-text-mask";

import { CommonControlProps } from "@common/components/Atoms/FormInputs/commonControlProps";
import { IconCheck, IconFrown } from "@common/components/Atoms/Icons";

interface PhoneInputProps extends CommonControlProps {
    description?: string
    inputClassName?: string
    inputRef?: any
    isValid: boolean
    label?: string
    maxLength: number
    name: string
    onEnterKey?: (e: any) => void
    placeholder?: string
    readOnly?: boolean
    required?: boolean
    validationMessages: string[]
    value?: string | number
}

interface PhoneInputState {
    untouched: boolean
}


export class PhoneInput extends React.Component<PhoneInputProps, PhoneInputState> {

    static defaultProps = {
        autoComplete: "Off",
        inputClassName: "",
        isValid: true,
        maxLength: 255,
        name: "",
        readOnly: false,
        required: false,
        validationMessages: [],
    }

    constructor(props: PhoneInputProps) {
        super(props);
        this.state = {
            untouched: true
        };
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
    }

    onKeyPress(e) {
        if (e.key === "Enter" && !!this.props.onEnterKey) {
            e.preventDefault();
            e.persist();
            this.props.onEnterKey(e);
        }
    }

    onChange(event) {
        this.setState({ untouched: false });
        if(this.props.onChange) this.props.onChange(this.props.name, event.target.value);
    }

    onBlur() {
        if (this.props.onBlur) this.props.onBlur(this.props.name);
    }

    onFocus() {
        if (this.props.onFocus) this.props.onFocus(this.props.name);
    }

    render() {
        return (
            <div className="c-block">
                <div
                    className={
                        "c-control c-control--text " + (!this.props.isValid ? "has-error" : "")
                    }>
                    {this.props.label && (
                        <div className="c-control__label">
                            <label htmlFor={"minput_" + this.props.name}>{this.props.label}</label>
                            {this.props.description && <p>{this.props.description}</p>}
                        </div>
                    )}
                    <div className="c-control__wrapper">
                        <MaskedInput
                            id={`minput_${this.props.name}`}
                            name={this.props.name}
                            mask={["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
                            value={this.props.value}
                            required={this.props.required}
                            readOnly={this.props.readOnly}
                            autoComplete="no"
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            placeholder={this.props.placeholder}
                            maxLength={this.props.maxLength}
                            onKeyPress={this.onKeyPress}
                            ref={this.props.inputRef}

                            render={(ref, props) => (
                                <input
                                    {...props}
                                    className={
                                        `c-control__input ${this.props.inputClassName} ${(!this.props.isValid ? "has-error" : "")}`
                                    }
                                    type="tel"
                                    id={"input_" + this.props.name}
                                    name={this.props.name}
                                    ref={ref}
                                />
                            )}
                        />
                        {this.props.isValid &&
                            !this.state.untouched && (
                                <div className="c-control__valid">
                                    <IconCheck />
                                </div>
                            )}
                    </div>
                    {!this.props.isValid && (
                        <div className="c-control__message">
                            <IconFrown />
                            {this.props.validationMessages.map((msg, ind) => (
                                <span key={ind}>{msg + " "}</span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

